export const formatRows = (listaItems) =>
  listaItems.map((item, index) => {
    let datosCli;

    try {
      datosCli = JSON.parse(item?.oca_datos_cli || "{}");
    } catch (e) {
      datosCli = {};
    }

    return {
      index: index + 1,
      id: item.oca_id || "Id no disponible",
      cli_name: item?.cli_name
        ? item.cli_name.trim()
        : "Sin Informacion",
      createdAt: item.createdAt || "Fecha de creación no disponible",
      totalpedido: item.monto_total_desc || "0",
      formapago: item.oca_pago_estado ?? "Forma de pago no disponible",
      observacion: datosCli,
    };
  });
